// Mock data for Patrick's Edu Care website

export const servicesData = [
  {
    id: 1,
    title: "Study Abroad Consulting",
    description: "Expert guidance to help you choose the right country, university, and course that aligns with your career goals and aspirations.",
    icon: "GraduationCap"
  },
  {
    id: 2,
    title: "Career Counselling",
    description: "Personalized counselling sessions to understand your strengths, interests, and help you make informed decisions about your academic journey.",
    icon: "Users"
  },
  {
    id: 3,
    title: "University Admissions",
    description: "Complete assistance with university applications, essay writing, and securing admission to top universities worldwide.",
    icon: "School"
  },
  {
    id: 4,
    title: "Documentation Support",
    description: "Comprehensive help with preparing, organizing, and verifying all necessary documents for your study abroad application.",
    icon: "FileText"
  },
  {
    id: 5,
    title: "Visa Applications",
    description: "End-to-end visa application support including documentation, interview preparation, and guidance through the entire visa process.",
    icon: "Passport"
  },
  {
    id: 6,
    title: "Travel Assistance",
    description: "Support with flight bookings, accommodation arrangements, and travel planning to ensure a smooth transition to your destination.",
    icon: "Plane"
  },
  {
    id: 7,
    title: "Pre-Departure Services",
    description: "Orientation sessions covering cultural adaptation, academic expectations, and practical tips for living abroad.",
    icon: "Briefcase"
  },
  {
    id: 8,
    title: "Post-Departure Support",
    description: "Continued assistance even after you reach your destination, helping you settle in and navigate any challenges.",
    icon: "HeadphonesIcon"
  }
];

export const destinationCountries = {
  european: [
    { id: 1, name: "Georgia", flag: "🇬🇪" },
    { id: 2, name: "Moldova", flag: "🇲🇩" },
    { id: 3, name: "Bulgaria", flag: "🇧🇬" },
    { id: 4, name: "Serbia", flag: "🇷🇸" },
    { id: 5, name: "Hungary", flag: "🇭🇺" },
    { id: 6, name: "Poland", flag: "🇵🇱" },
    { id: 7, name: "Germany", flag: "🇩🇪" },
    { id: 8, name: "Austria", flag: "🇦🇹" },
    { id: 9, name: "Slovakia", flag: "🇸🇰" },
    { id: 10, name: "Lithuania", flag: "🇱🇹" },
    { id: 11, name: "Romania", flag: "🇷🇴" },
    { id: 12, name: "France", flag: "🇫🇷" }
  ],
  cis: [
    { id: 13, name: "Uzbekistan", flag: "🇺🇿" },
    { id: 14, name: "Kyrgyzstan", flag: "🇰🇬" },
    { id: 15, name: "Russia", flag: "🇷🇺" },
    { id: 16, name: "Kazakhstan", flag: "🇰🇿" },
    { id: 17, name: "Tajikistan", flag: "🇹🇯" }
  ],
  english: [
    { id: 18, name: "United Kingdom", flag: "🇬🇧" },
    { id: 19, name: "United States", flag: "🇺🇸" },
    { id: 20, name: "Australia", flag: "🇦🇺" },
    { id: 21, name: "New Zealand", flag: "🇳🇿" },
    { id: 22, name: "Ireland", flag: "🇮🇪" }
  ]
};

export const testimonialsData = [
  {
    id: 1,
    name: "Anjali Menon",
    course: "MBBS",
    university: "Tbilisi State Medical University, Georgia",
    testimonial: "Patrick's Edu Care guided me through every step of my MBBS admission in Georgia. From documentation to visa, their support was exceptional. Now living my dream of becoming a doctor!",
    image: "/img/stock/1571260899304-425eee4c7efc.webp"
  },
  {
    id: 2,
    name: "Aravind Krishnan",
    course: "MBBS",
    university: "Nicolae Testemitanu University, Moldova",
    testimonial: "Thanks to Patrick's Edu Care, I'm pursuing MBBS in Moldova with complete peace of mind. Their expertise made the entire process smooth and hassle-free.",
    image: "/img/stock/1667655861998-46fe4c29a4cf.webp"
  },
  {
    id: 3,
    name: "Sreelakshmi Nair",
    course: "BSc Nursing",
    university: "University of Georgia, Georgia",
    testimonial: "I'm grateful to Patrick's Edu Care for helping me secure admission for Nursing at University of Georgia. Their personalized counselling helped me choose the perfect course and university.",
    image: "/img/stock/1581065178047-8ee15951ede6.webp"
  },
  {
    id: 4,
    name: "Adithya Raj",
    course: "MBBS",
    university: "Caucasus University, Georgia",
    testimonial: "Choosing MBBS at Caucasus University through Patrick's Edu Care was the best decision. Their guidance and support throughout the admission process was outstanding!",
    image: "/img/stock/1604177091072-b7b677a077f6.webp"
  },
  {
    id: 5,
    name: "Vishnu Kumar",
    course: "Ausbildung (Vocational Training)",
    university: "Germany",
    testimonial: "Patrick's Edu Care made my Ausbildung dream in Germany come true! They handled everything from language requirements to visa processing. Highly recommend their Germany programs!",
    image: "/img/stock/4308093.webp"
  },
  {
    id: 6,
    name: "Divya Suresh",
    course: "BSc Nursing",
    university: "University of Pleven, Bulgaria",
    testimonial: "Pursuing Nursing at University of Pleven was the best decision I made, and Patrick's Edu Care made it possible. Their team is professional, caring, and always available to help.",
    image: "/img/stock/7580821.webp"
  },
  {
    id: 7,
    name: "Karthik Pillai",
    course: "Veterinary Medicine",
    university: "Technical University of Moldova, Moldova",
    testimonial: "My passion for veterinary medicine found its path through Patrick's Edu Care. They helped me get admission at Technical University of Moldova and supported me throughout the journey.",
    image: "/img/stock/3781346.webp"
  },
  {
    id: 8,
    name: "Aishwarya Nambiar",
    course: "Mechatronics Engineering",
    university: "Technical University, Slovakia",
    testimonial: "Studying Mechatronics in Slovakia has been an incredible experience. Patrick's Edu Care's guidance through the admission process was top-notch and very professional.",
    image: "/img/stock/16504591.webp"
  },
  {
    id: 9,
    name: "Rohan Varghese",
    course: "Master's in Cybersecurity",
    university: "Comenius University, Slovakia",
    testimonial: "Patrick's Edu Care helped me pursue my Master's in Cybersecurity in Slovakia. Their expertise in European education made the entire process seamless and stress-free.",
    image: "/img/stock/1637589316488-6d4c41b335cd.webp"
  }
];

export const galleryData = [
  {
    id: 7,
    type: "image",
    url: "/img/u9llq88u_aa2704d0-48f7-4e88-b6a6-77ae116059cf.webp",
    title: "Indoor football tournament — our boys at the goal post",
    category: "sports"
  },
  {
    id: 8,
    type: "image",
    url: "/img/yw505o08_img_2528.webp",
    title: "Champions! Cricket tournament trophy moment",
    category: "sports"
  },
  {
    id: 9,
    type: "image",
    url: "/img/a7dqo5r9_img_8977.webp",
    title: "Trophy lift — students celebrate their tournament win",
    category: "sports"
  },
  {
    id: 10,
    type: "image",
    url: "/img/gey0q2pf_img_9528.webp",
    title: "VNMU Cricket Association — proudly sponsored by Patrick's Edu Care",
    category: "sports"
  },
  {
    id: 11,
    type: "image",
    url: "/img/xdpqtmzp_78addfd6-3751-48d0-8c9e-b1d51a281d7d.webp",
    title: "Batch arrival — students received at the airport abroad",
    category: "students"
  },
  {
    id: 12,
    type: "image",
    url: "/img/rrl55db5_048153f3-d897-4b3a-8943-e575dbaa8249.webp",
    title: "Students touch down — luggage loaded, dreams ahead",
    category: "students"
  },
  {
    id: 13,
    type: "image",
    url: "/img/zbmkt0tl_e48bb3d9-6276-400a-8ff5-01c44bb558a4.webp",
    title: "Waiting to board — first flight of a lifetime",
    category: "students"
  },
  {
    id: 14,
    type: "image",
    url: "/img/jfd29qbf_img_0077.webp",
    title: "Send-off at Cochin International — Patrick's team with the batch",
    category: "students"
  },
  {
    id: 15,
    type: "image",
    url: "/img/ttswl88m_img_0094.webp",
    title: "A proud family send-off at the Kochi airport",
    category: "students"
  },
  {
    id: 16,
    type: "image",
    url: "/img/ojmv6qfn_img_2951.webp",
    title: "Patrick's students at Delhi Airport — gateway to their dream",
    category: "students"
  },
  {
    id: 17,
    type: "image",
    url: "/img/zfflgrz9_img_3030.webp",
    title: "Families & students together before the big farewell",
    category: "students"
  },
  {
    id: 18,
    type: "image",
    url: "/img/yme5619l_608f39ae-c9df-4dc4-b8f6-ff4b315c19f3.webp",
    title: "Boarding day — Patrick's students at the departure gate",
    category: "students"
  },
  {
    id: 19,
    type: "image",
    url: "/img/i2smcbv4_936bb3e2-7cdc-4911-bb17-058995ec0ff5.webp",
    title: "Pre-Departure Briefing & Send-Off 2022 — full house with our students",
    category: "events"
  },
  {
    id: 20,
    type: "image",
    url: "/img/yakqo4zh_cbe107d7-0d77-4378-a4a9-cf890edf37a1.webp",
    title: "Roses, blessings & sendoff — 2022 batch for Caucasus University, Georgia",
    category: "events"
  },
  {
    id: 21,
    type: "image",
    url: "/img/d8gu8fve_cddd292e-fbe4-488b-990d-dca43f7b3942.webp",
    title: "Honouring our chief guests — Pre-Departure Briefing 2022",
    category: "events"
  },
  {
    id: 22,
    type: "image",
    url: "/img/1p31f9mp_2662bde8-0af0-440a-9006-bb50939e26d4.webp",
    title: "Touched down — our students arrive at their university city",
    category: "students"
  },
  {
    id: 23,
    type: "image",
    url: "/img/tj45l3nz_b26bc874-c4e3-4b63-9f33-744c517352c2.webp",
    title: "Welcome to Georgia — student & family at arrival",
    category: "students"
  },
  {
    id: 24,
    type: "image",
    url: "/img/952lyoc1_e4de7f75-d98d-4721-b9e1-ede28bfb9a38.webp",
    title: "All set for boarding — passports, bags & dreams",
    category: "students"
  },
  {
    id: 25,
    type: "image",
    url: "/img/g496swyw_f34160cd-81a9-4407-8d32-4f46d6e8d72e.webp",
    title: "Touched down abroad — three friends, one journey",
    category: "students"
  },
  {
    id: 26,
    type: "image",
    url: "/img/igkhw7li_img_6892.webp",
    title: "Real clinical exposure — our MBBS student in the operating theatre",
    category: "clinical"
  },
  {
    id: 27,
    type: "image",
    url: "/img/vi6a042n_img_8096.webp",
    title: "Free FMGE coaching by Arise Medical Academy — packed house of our students",
    category: "events"
  },
  {
    id: 28,
    type: "image",
    url: "/img/0tmishde_img_8103.webp",
    title: "Hundreds of students in focused study — exclusive FMGE prep session",
    category: "events"
  },
  {
    id: 29,
    type: "image",
    url: "/img/9jz2qug4_img_8120.webp",
    title: "FMGE classroom in full swing — taking notes for the big exam",
    category: "events"
  },
  {
    id: 30,
    type: "image",
    url: "/img/bg0ssljx_img_8540.webp",
    title: "Group photo with Arise Medical Academy faculty — free FMGE prep, exclusive to Patrick's students",
    category: "events"
  },
  {
    id: 31,
    type: "image",
    url: "/img/itxnbg98_photo-2026-03-21-22-08-47.webp",
    title: "BSc Nursing in Georgia — students settle in at their new home",
    category: "students"
  },
  {
    id: 32,
    type: "image",
    url: "/img/4x8h571g_photo-2026-03-21-11-27-39.webp",
    title: "Send-off at the airport — BSc Nursing batch headed to Georgia",
    category: "students"
  },
  {
    id: 33,
    type: "image",
    url: "/img/eyd4lyjh_photo-2026-02-06-10-18-07.webp",
    title: "Welcome to Tbilisi — BSc Nursing students arrive at Georgia",
    category: "students"
  },
  {
    id: 34,
    type: "image",
    url: "/img/4il48g0g_photo-2026-02-23-14-52-39.webp",
    title: "First day in a new country — BSc Nursing aspirant ready for class",
    category: "students"
  },
  {
    id: 35,
    type: "image",
    url: "/img/0ux1sx1p_photo-2026-02-24-05-32-17.webp",
    title: "BSc Nursing batch in Georgia — fresh dreams, fresh start",
    category: "students"
  },
  {
    id: 36,
    type: "image",
    url: "/img/jurk4h3q_photo-2025-12-04-11-25-53.webp",
    title: "September 2025 batch — students & families before flying to Georgia",
    category: "students"
  },
  {
    id: 37,
    type: "image",
    url: "/img/qj3knh7n_e4344f71-f270-43db-951b-ff103dd12e08.webp",
    title: "MBBS White Coat Ceremony 2025 — our future doctors, suited up",
    category: "clinical"
  }
];

export const statsData = [
  { label: "Students Placed", value: "2,500+" },
  { label: "Partner Universities", value: "500+" },
  { label: "Countries", value: "15+" },
  { label: "Success Rate", value: "98%" }
];

export const programsData = [
  {
    id: 1,
    category: "Medical Programs",
    icon: "Stethoscope",
    programs: [
      { name: "MBBS", countries: ["Georgia", "Uzbekistan", "Bulgaria", "Moldova"] },
      { name: "Veterinary Medicine", countries: ["Moldova"] }
    ]
  },
  {
    id: 2,
    category: "Nursing Programs",
    icon: "HeartPulse",
    programs: [
      { name: "BSc Nursing", countries: ["Georgia", "Bulgaria"] }
    ]
  },
  {
    id: 3,
    category: "Business Programs",
    icon: "Briefcase",
    programs: [
      { name: "BBA (Bachelor of Business Administration)", countries: ["Georgia", "Moldova"] },
      { name: "MBA (Master of Business Administration)", countries: ["Georgia", "Moldova"] }
    ]
  },
  {
    id: 4,
    category: "Other Programs",
    icon: "BookOpen",
    programs: [
      { name: "Bachelor's Programs", countries: ["Various Countries"] },
      { name: "Master's Programs", countries: ["Various Countries"] }
    ]
  }
];

// API base URL
const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Form submission functions
export const submitContactForm = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Contact form error:', error);
    return { success: false, message: 'Failed to send message. Please try again.' };
  }
};

export const submitEligibilityForm = async (formData) => {
  try {
    const response = await fetch(`${API_URL}/eligibility`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Eligibility form error:', error);
    return { success: false, message: 'Failed to submit form. Please try again.' };
  }
};

// Mock gallery upload/delete
export const uploadGalleryItem = async (file) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("File uploaded:", file.name);
      resolve({
        success: true,
        item: {
          id: Date.now(),
          type: file.type.startsWith('image') ? 'image' : 'video',
          url: URL.createObjectURL(file),
          title: file.name,
          category: 'uploaded'
        }
      });
    }, 1500);
  });
};

export const deleteGalleryItem = async (itemId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Item deleted:", itemId);
      resolve({ success: true, message: "Item deleted successfully" });
    }, 500);
  });
};